import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "17",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "url(#a)",
  d: "M.334 0h16v16h-16z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("pattern", {
    id: "a",
    patternContentUnits: "objectBoundingBox",
    width: "1",
    height: "1"
  }, [
    /*#__PURE__*/_createElementVNode("use", {
      "xlink:href": "#b",
      transform: "scale(.01042)"
    })
  ]),
  /*#__PURE__*/_createElementVNode("image", {
    id: "b",
    width: "96",
    height: "96",
    "xlink:href": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAPpSURBVHgB7d2/TxNxGMfx53vKj6YoLTARhvsDDIH/ABYsG51MnLoaE1qIgxvtrnDEwRHYnKwbZYLdpTE4c4MaxyZGhdPe1zvI1wjetfer91zD55UQGmgZnnfbe3oDJ4iZXtkr2JZVHb9XqI3lJwuUguJkzpyZub8/qtHBmyeLJjESxEQNXmiyRpIKYxMFGsunMn+aLuZpqjjh3jSdCbCGSD3AzcGrnzMFUNhCpBbAb/AKcwAl9RADD9Bv8EpGAiiphRhYgKCDVzIWQDGdr3ejd2h3UCESDxB28EpGA/wlnFfEiEaNpEMkFiDq4JWsB1CSDhE7QNzBK8MSQEkqhEYx6I9eVeXvizMhZD3O8IeRlFSxunRWevl+i2KIHGB2ZX3L7n43btvgbzr/cV6f32zVKKJIAWZXamvOa7BOcEkS7Tx4drhEEYQOoJdquvOWs0dwjbC15sLzQ51CChXAHb4l5bFT/Fa/7XiTha4ljsNGCBxAX6sV3OG7Nwn86PYv0VyoNwM/QQMHsH7KHcLw+3K2o4Xut9xO0PsHCuBuPM63CkEwzoo6v3kUaD3tG2Du4XoVG094kmSg9bRngLlSbckmYRBEEmQ99Q3gbjxSyiZBLP3WU88AWDeT1Hs99QxgXR1wPR8Akei25b3ExDoZB/EhADMEYIYAzBCAGQIwQwBmCMAMAZghADMEYIYAzBCAGQIwQwBmCMAMAZghADMEYIYAzBCAGQIwQwBmCMAMAZghADMEYIYAzBCAGQIwQwBmCMAMAZghADMEYIYAzBCAGQIwQwBmCMAMAZghADMEYIYAzBCAGQIwQwBmCMAMAZghADMEYIYAzDwDCEkdgoQJz5l6Bhi5oH1B1CZIhBDU/rBd8vwHuJ4BzBOj0xWiTFeXcYIYnCeyqXVl2e/3vseAry3DtIVYdv4A3o4iuhy+LZfbxqrpd5+eB2E3grh6JUAEmq2Vew3/8j7Ux6eWcSJIbBCEYhNttI2VvsfRQGvo5yPDcI4kDYJAJMnGR5+D7k2BPwd8aRl1IcUBQU9S2Lun26v1oPcP9UFsxKIa1lN/7rp5t3tRD/OYUAGwnvpT62bbKIfaGkOfisB6+j9nSen0Wzf9RDoXhPX0Oluzy1GG74p8Ms5dT7Xx4m1/OzJzudHy6YvVE4ookesJ649fV6QQ7mWbdIpoyC5n617yvPH26eI+xZToFbXjhBiSAIkNXhnINeWjhMh4gMQHrwwkgBImREYDDGzwykADKEFCZCzAwAevpBJA6RUiIwFSG7ySagDFKwRzgNQHr7AEUP4NwRSAbfAKawDFDTF6b6o6np9MpUCxmO9MT03scg5e+QPQ1XV3TOu8jgAAAABJRU5ErkJggg=="
  })
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render };